// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"kT","productsContainer":"lT","searchVerticalReco":"mT","heading":"nT"};